import { render, staticRenderFns } from "./CustomerResponsesComponent.vue?vue&type=template&id=3486dc85&scoped=true"
import script from "./CustomerResponsesComponent.vue?vue&type=script&lang=js"
export * from "./CustomerResponsesComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerResponsesComponent.vue?vue&type=style&index=0&id=3486dc85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486dc85",
  null
  
)

export default component.exports